/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import { selfCheckInPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getSelfCheckinOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[selfCheckInPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

/**
 * Get the pod icons of the event
 * @param  {BraindateEvent} event - Event to get the pod icons from
 * @return {Array<string>} Pod icons
 */
export function getSelfCheckinOneOnOnePodIcons(
  event: BraindateEvent,
): ?Array<string> {
  return (getSelfCheckinOptions(event) || {})['braindate-pods-icons'];
}

/**
 * Get the group pod icons of the event
 * @param  {BraindateEvent} event - Event to get the group pod icons from
 * @return {Array<string>} Group pod icons
 */
export function getSelfCheckinGroupPodIcons(
  event: BraindateEvent,
): ?Array<string> {
  return (getSelfCheckinOptions(event) || {})['group-pods-icons'];
}
